import React, { useState, useEffect } from "react";
import { FiChevronLeft, FiChevronRight, FiX } from "react-icons/fi";
import { AnimatePresence, motion } from "framer-motion";

const certImages = [
  "/assets/certifikat1.png",
  "/assets/certifikat2.png",
  "/assets/certifikat3.png",
  "/assets/certificate-4.webp",
];

export default function Certificates() {
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openLightbox = (i) => {
    setIndex(i);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const showNext = () => {
    setIndex((prev) => (prev + 1) % certImages.length);
  };

  const showPrev = () => {
    setIndex((prev) => (prev - 1 + certImages.length) % certImages.length);
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === "ArrowRight") {
        showNext();
      } else if (e.key === "ArrowLeft") {
        showPrev();
      } else if (e.key === "Escape") {
        closeLightbox();
      }
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen]);

  return (
    <>
      <div className="gap-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
        {certImages.map((src, i) => (
          <div
            key={i}
            onClick={() => openLightbox(i)}
            className="shadow-md hover:shadow-xl rounded-lg overflow-hidden transition cursor-pointer"
          >
            <img
              src={src}
              alt={`Certificate ${i + 1}`}
              className="w-full h-48 object-cover"
            />
          </div>
        ))}
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="z-50 fixed inset-0 flex justify-center items-center bg-black/80 px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="absolute inset-0" onClick={closeLightbox} />

            <button
              onClick={closeLightbox}
              aria-label="Zavřít"
              className="top-4 right-4 z-10 absolute bg-dark lg:hover:bg-white/30 p-2 rounded-full text-light cursor-pointer"
            >
              <FiX size={32} />
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                showPrev();
              }}
              aria-label="Předchozí"
              className="top-1/2 left-6 md:left-12 z-50 absolute bg-dark lg:hover:bg-white/30 p-0.5 md:p-2 rounded-full text-light -translate-y-1/2 cursor-pointer"
            >
              <FiChevronLeft size={32} />
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                showNext();
              }}
              aria-label="Další"
              className="top-1/2 right-6 md:right-12 z-50 absolute bg-dark lg:hover:bg-white/30 p-0.5 md:p-2 rounded-full text-light -translate-y-1/2 cursor-pointer"
            >
              <FiChevronRight size={32} />
            </button>

            <div className="top-4 left-4 z-10 absolute font-semibold text-light text-lg">
              {index + 1} / {certImages.length}
            </div>

            <motion.img
              key={index}
              src={certImages[index]}
              alt={`Certifikát ${index + 1}`}
              className="z-10 rounded-xl w-[90vw] max-w-3xl max-h-[80vh] object-contain"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.3 }}
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
